import { css } from '@emotion/react';

import { styled } from '../../../../../../styled';
import { Theme } from '../../../../../../theme/interface/detailed';
import { useTheme } from '../../../../../../theme/useTheme';

export const FileIcon = styled(({ className }: { className: string }) => {
	const theme = useTheme();
	return (
		<div className={className}>
			<svg
				width={parseInt(theme.allSettings.icons.fileIconInsideAttachmentPreview.width + '')}
				height={parseInt(theme.allSettings.icons.fileIconInsideAttachmentPreview.height + '')}
				viewBox="10 8 12 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
					fill={theme.allSettings.icons.fileIconInsideAttachmentPreview.backgroundColor}
				/>
				<path
					d="M20.9403 13.334L17.3337 9.72732C17.0803 9.47398 16.747 9.33398 16.3937 9.33398H12.667C11.567 9.33398 10.667 10.234 10.667 11.334V20.6673C10.667 21.7673 11.567 22.6673 12.667 22.6673H19.3337C20.4337 22.6673 21.3337 21.7673 21.3337 20.6673V14.274C21.3337 13.9207 21.1937 13.5873 20.9403 13.334ZM19.0603 13.334H18.0003C17.6337 13.334 17.3337 13.034 17.3337 12.6673V11.6073L19.0603 13.334ZM20.0003 20.6673C20.0003 21.034 19.7003 21.334 19.3337 21.334H12.667C12.3003 21.334 12.0003 21.034 12.0003 20.6673V11.334C12.0003 10.9673 12.3003 10.6673 12.667 10.6673H16.0003V12.6673C16.0003 13.7673 16.9003 14.6673 18.0003 14.6673H20.0003V20.6673ZM14.667 14.6673H14.0003C13.6337 14.6673 13.3337 14.3673 13.3337 14.0007C13.3337 13.634 13.6337 13.334 14.0003 13.334H14.667C15.0337 13.334 15.3337 13.634 15.3337 14.0007C15.3337 14.3673 15.0337 14.6673 14.667 14.6673ZM18.0003 17.334H14.0003C13.6337 17.334 13.3337 17.034 13.3337 16.6673C13.3337 16.3007 13.6337 16.0007 14.0003 16.0007H18.0003C18.367 16.0007 18.667 16.3007 18.667 16.6673C18.667 17.034 18.367 17.334 18.0003 17.334ZM16.667 20.0007H14.0003C13.6337 20.0007 13.3337 19.7007 13.3337 19.334C13.3337 18.9673 13.6337 18.6673 14.0003 18.6673H16.667C17.0337 18.6673 17.3337 18.9673 17.3337 19.334C17.3337 19.7007 17.0337 20.0007 16.667 20.0007Z"
					fill={theme.allSettings.icons.fileIconInsideAttachmentPreview.fill}
				/>
			</svg>
		</div>
	);
})(
	({
		theme: {
			allSettings: {
				icons: {
					// eslint-disable-next-line @typescript-eslint/no-unused-vars
					fileIconInsideAttachmentPreview: { width, height, ...others },
				},
			},
		},
	}: {
		theme: Theme;
	}) => ({ ...others }),
	css`
		border-radius: 50%;
	`
);
